export default "__VITE_ASSET__Cm_As9sj__"